import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { jobsApi } from "../../api/endpoints";
import type { JobListingCreate, JobListingUpdate } from "@endeks/shared";

export function useJobListings(active?: boolean) {
  return useQuery({
    queryKey: ["jobs", active],
    queryFn: () => jobsApi.list(active).then((r) => r.data),
  });
}

export function useJobListing(id: string) {
  return useQuery({
    queryKey: ["jobs", id],
    queryFn: () => jobsApi.get(id).then((r) => r.data),
    enabled: !!id,
  });
}

export function useCreateJobListing() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: JobListingCreate) => jobsApi.create(data).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["jobs"] }),
  });
}

export function useUpdateJobListing() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...data }: JobListingUpdate & { id: string }) =>
      jobsApi.update(id, data).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["jobs"] }),
  });
}

export function useDeleteJobListing() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => jobsApi.delete(id).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["jobs"] }),
  });
}
